import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonDataTable from '../../../components/CommonDataTable';
import HistoryIcon from '@mui/icons-material/History';
import { getLocationList } from '../../../services/location/location';
const rawColumns = [
  { field: 'locationId', headerName: 'Location ID', width: 180 },
  { field: 'locationName', headerName: 'Location Name', width: 150 },
  { field: 'locationType', headerName: 'Location Type', width: 130 },
  { field: 'addressLine1', headerName: 'Address Line 1', width: 180 },
  { field: 'addressLine2', headerName: 'Address Line 2', width: 180 },
  { field: 'city', headerName: 'City', width: 120 },
  { field: 'state', headerName: 'State', width: 120 },
  { field: 'country', headerName: 'Country', width: 120 },
  { field: 'pincode', headerName: 'Pincode', width: 100 },
  {
    field: 'operationalGeoAreas',
    headerName: 'Operational Geo Areas',
    width: 200,
    renderCell: (params) => (
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <IconButton
          size="small"
          onClick={() => handleGeoAreasClick(params.row)}
          aria-label="view geo areas"
        >
          <HistoryIcon fontSize="small" />
        </IconButton>
      </div>
    )
  },
  { field: 'serviceLevel', headerName: 'Service Level', width: 150 },
  { field: 'operatingHours', headerName: 'Operating Hours', width: 150 },
  { field: 'createdBy', headerName: 'Created By', width: 150 },
  { field: 'updatedBy', headerName: 'Updated By', width: 150 },
];

const handleGeoAreasClick = (data) => {
  // You can implement modal or tooltip to show detailed geo areas
  // console.log('Geo Areas clicked for:', data);
};

export default function LocationMgtList({ onCreateClick, refreshKey, onView, onEdit }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [tableRows, setTableRows] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const loadList = useCallback(async (page, pageSize) => {
    try {
      const response = await getLocationList(page, pageSize);

      if (response?.data?.length) {
        const formattedRows = response.data.map(field => ({
          locationId: field.locationID,
          locationName: field.locationName,
          locationType: field.locationType,

          addressLine1: field.address?.addressLine1 || '',
          addressLine2: field.address?.addressLine2 || '',
          city: field.address?.city || '',
          state: field.address?.state || '',
          country: field.address?.Country || '',
          pincode: field.address?.Pincode || '',

          operationalGeoAreas: field.operationalGeoAreas?.join(', ') || '',
          serviceLevel: field.serviceLevel?.join(', ') || '',
          operatingHours: field.operatingHours,

          createdBy: field.createdBy,
          updatedBy: field.updatedBy,

          __original: field,
          id: field._id
        }));


        setTableRows(formattedRows);
        setTotalCount(response.pagination.totalRecords);
      } else {
        setTableRows([]);
        setTotalCount(0);
      }
    } catch (err) {
      console.error(err);
    }
  }, []);


  useEffect(() => {
    loadList(page, pageSize);
  }, [refreshKey, page, pageSize, loadList]);


  // Menu handling
  const handleOpenMenu = (e, row) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };
  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const actionColumn = {
    field: "__actions",
    headerName: "",
    width: 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <IconButton
        size="small"
        onClick={(e) => handleOpenMenu(e, params.row)}
        aria-label="row actions"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
    ),
  };

  const allPossibleColumns = useMemo(() => [actionColumn, ...rawColumns], []);
  const initialVisible = useMemo(
    () => allPossibleColumns.map((c) => c.field),
    [allPossibleColumns]
  );

  return (
    <>
      <CommonDataTable
        allPossibleColumns={allPossibleColumns}
        initialVisible={initialVisible}
        initialRows={tableRows}
        height={520}
        rowsPerPageOptions={[10, 25, 50, 100]}
        showCreateButton={true}
        createButtonText="Create New Location"
        createButtonIcon="bi-plus-lg"
        onCreateClick={onCreateClick}
        createButtonVariant="contained"
        createButtonColor="primary"
        page={page}
        pageSize={pageSize}
        rowCount={totalCount}
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
          setPage(0);
        }}
        onDataRefresh={async ({ filters = [], page: p = 0, pageSize: ps = pageSize } = {}) => {

          console.log("ASN ....................... received onDataRefresh:", { filters, page: p, pageSize: ps });

        }}
      />

      <Menu open={!!menuAnchorEl} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>
        <MenuItem onClick={() => onView(menuRow.__original)}>
          <i className="bi bi-eye me-2" /> View
        </MenuItem>
        <MenuItem onClick={() => onEdit(menuRow.__original)}>
          <i className="bi bi-pencil me-2" /> Edit
        </MenuItem>
      </Menu>
    </>
  );
}
